import dialogPolyfill from "../../../node_modules/dialog-polyfill/dist/dialog-polyfill.esm.js";

function stopVideo(modal) {
  const iframe = modal.querySelector("iframe");
  const video = modal.querySelector("video");
  if (iframe) {
    const url = new URL(iframe.src);
    url.searchParams.set("autoplay", "0");
    iframe.src = url;

    const parentElement = iframe.parentElement;
    const index = Array.from(parentElement.children).indexOf(iframe);
    parentElement.removeChild(iframe);
    parentElement.insertBefore(iframe, parentElement.children[index]);
  }
  if (video) {
    video.stop();
  }
}

//#region Dialogs
const dialogs = document.querySelectorAll("dialog");
for (let i = 0, count = dialogs.length; i < count; i++) {
  const dialog = dialogs[i];
  dialogPolyfill.registerDialog(dialog);

  // Handles "faux" close button using empty anchor to clear the `target:`
  const closeButton = dialog.querySelector(`a[href="#close"`);
  if (closeButton) {
    closeButton.addEventListener("click", function(event) {
      dialog.close();

      stopVideo(dialog);
    });
  }
}
//#endregion

/**
 * Opens faux modal using CSS `target:` to actual modal.
 */
 function openModalByHash() {
  const hash = window.location.hash;
  if (hash) {
    const modal = document.querySelector(`dialog[id="${hash.substring(1)}"]`);
    if (modal) {
      !modal.open && modal.show();

      const iframe = modal.querySelector("iframe");
      const video = modal.querySelector("video");
      if (iframe) {
        const url = new URL(iframe.src);
        url.searchParams.set("autoplay", "1");
        iframe.src = url;
      }
      if (video) {
        video.play();
      }
    }
  }
}

window.addEventListener("hashchange", openModalByHash, false);
openModalByHash();

document.addEventListener("click", ({ target }) => {
  if (target.matches(".backdrop")) {
    const previousElementSibling = target.previousElementSibling;
    if (previousElementSibling.matches("dialog")) {
      previousElementSibling.close();
      stopVideo(previousElementSibling);

      // If the dialog was open through anchor link, clicking close should go back.
      document.querySelector(`:target`) && window.history.go(-1);
    }
  }
});
